import * as cx from 'classnames';
import { count_POSTS_AND_ANSWERS_IN_LAST_WEEK } from 'mk/autogenerated/translations/CoverPreview.646768081a84e538d5deabcea461a618'
import { upperCaseFirst } from 'mk/bazaar/common/filters';
import { photoUrl } from 'mk/photo/photoUrl';
import stylesOfTopicHeader from 'mk2/apps/forum/components/TopicHeader.mscss';
import Img from 'mk2/components/Img';
import {
    FailedPhotoUpload,
    PendingPhotoUpload,
    PhotoUploadStatus,
    SuccessfulPhotoUpload,
} from 'mk2/helpers/form.reducers';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import { PhotoEntity, PhotoPreviewEntity, PhotoPreviewSchema, PhotoSchema } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './CoverPreview.mscss';

interface OwnProps {
    className?: string;
    upload: PendingPhotoUpload | SuccessfulPhotoUpload | FailedPhotoUpload;
    nameForCoverPreview: string;
}

interface OwnState {
    photoLoaded: boolean;
}

interface StateProps {
    uploadedPhoto: PhotoEntity | null;  // not null if upload.status === UploadStatus.SUCCESS
    uploadedPhotoPreview: PhotoPreviewEntity | null;  // not null if upload.status === UploadStatus.PENDING
}

interface DispatchProps {
}

type Props = OwnProps & StateProps & DispatchProps;

class CoverPreview extends React.Component<Props, OwnState> {

    constructor(props: Props) {
        super(props);
        this.state = {photoLoaded: false};
    }

    public render() {
        const { className, upload, uploadedPhoto, uploadedPhotoPreview, nameForCoverPreview } = this.props;

        let trimByX = false;
        let backgroundImage = null;
        if (uploadedPhotoPreview) {
            trimByX = uploadedPhotoPreview.originalWidth / uploadedPhotoPreview.originalHeight >= 980 / 335;
            backgroundImage = `url('${uploadedPhotoPreview.imgBase64Data}')`;
        }
        if (upload.status === PhotoUploadStatus.SUCCESS && this.state.photoLoaded) {
            trimByX = uploadedPhoto.width / uploadedPhoto.height >= 980 / 335;
            backgroundImage = `url('${photoUrl(uploadedPhoto, 's1600x1600')}')`;
        }

        return (
            <div
                className={cx(
                    styles.CoverPreview,
                    (upload.status === PhotoUploadStatus.FAILURE && styles['CoverPreview--failure']),
                    className,
                )}
            >
                {upload.status === PhotoUploadStatus.SUCCESS && (
                    <div
                        className={cx(styles.CoverPreview__hiddenDivToCacheUploadedImg)}
                    >
                        <Img
                            src={photoUrl(uploadedPhoto, 's1600x1600')}
                            width={uploadedPhoto.width}
                            height={uploadedPhoto.height}
                            onLoad={this.handleHiddenImageLoaded}
                            onError={this.handleHiddenImageFailed}
                            lazy={false}
                        />
                    </div>
                )}
                <div
                    className={cx(stylesOfTopicHeader.TopicHeader__cover)}
                >
                    {upload.status === PhotoUploadStatus.PENDING && upload.progress >= 0 && (
                        <div key="mask" style={{width: (100 - upload.progress * 100) + '%'}} className={styles.CoverPreview__mask} />
                    )}
                    <div
                        id="preview_of_new_cover"
                        className={cx(
                            stylesOfTopicHeader.TopicHeader__cover_photo,
                            trimByX ?
                                stylesOfTopicHeader['TopicHeader__cover_photo--trim_x'] :
                                stylesOfTopicHeader['TopicHeader__cover_photo--trim_y'],
                        )}
                        style={{backgroundImage}}
                    />
                    <div className={stylesOfTopicHeader.TopicHeader__cover_text}>
                        <h1 className={stylesOfTopicHeader.TopicHeader__cover_topic_name}>
                            {upperCaseFirst(nameForCoverPreview)}
                        </h1>
                        <div
                            className={stylesOfTopicHeader.TopicHeader__cover_posts}
                            dangerouslySetInnerHTML={{__html: interpolate(count_POSTS_AND_ANSWERS_IN_LAST_WEEK, {count: 0})}}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private handleHiddenImageLoaded = (e) => {
        this.setState({photoLoaded: true});
    };

    private handleHiddenImageFailed = (e) => {
        this.setState({photoLoaded: false});
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { upload } = ownProps;
    const uploadedPhotoPreview: PhotoPreviewEntity = getDenormalizedEntity<PhotoPreviewEntity>(state, PhotoPreviewSchema, upload.fileName);
    const uploadedPhoto: PhotoEntity = upload.status === PhotoUploadStatus.SUCCESS
        ? getDenormalizedEntity<PhotoEntity>(state, PhotoSchema, (upload as SuccessfulPhotoUpload).photoId)
        : null;
    return {
        uploadedPhoto,
        uploadedPhotoPreview,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {};

export default connect(mapStateToProps, mapDispatchToProps)(CoverPreview);
